import { forwardRef, type HTMLAttributes } from 'react';

export interface ThemedImgProps
  extends Omit<HTMLAttributes<HTMLImageElement>, 'src'> {
  lightSrc: string;
  darkSrc?: string;
}

export const ThemedImg = forwardRef<HTMLImageElement, ThemedImgProps>(
  function ThemedImg({ lightSrc, darkSrc, ...attrs }, ref) {

    return <img ref={ref} src={lightSrc} {...attrs} />;
  }
);
